import { UserService } from './shared/services/userService';

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SocketService } from './shared/services/socket.service';
import { NotifierService } from './shared/services/notifier.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {

  constructor(
        private translate: TranslateService,
        private socketService: SocketService,
        private notifier: NotifierService,
        private userService: UserService,
      ) {
  
  }

  ngOnInit() {
    // Subscribing to socket-alert
    
    this.socketService.getAlerts().subscribe(data => {
      if(this.userService.token == null || this.userService.token == undefined || this.userService.token == '') {
        return;
      }
      const jsonData = JSON.parse(data);
      let time = 0;
      // If level === info setting custom time
      if (jsonData.level === 'info') {
        time = 1000;
      }
      // If title has not been set, set 'Alarms'
      const title = jsonData.title ? jsonData.title : 'Alarms';
      this.notifier.show(jsonData.message, title, jsonData.level, time);
      if(environment.production == false) {
        // If not in production, print all of the jsonData object
        console.log(jsonData);
      }
    });

    // this language will be used as a fallback when a translation isn't found in the current language
    this.translate.setDefaultLang('en');
    // the lang to use, if the lang isn't available, it will use the current loader to get them
    this.translate.use('it');
  }
}
